import {  Box } from "@mui/material";

const RequiredAsterisk = () => (
    <Box
      component="span"
      sx={{
        color: "#ebb349",
        fontWeight: "bold",
      }}
    >
      *
    </Box>
);

export default RequiredAsterisk